import classNames from "classnames";
import { Icon } from "@/comn/components";
import { _TEST1234 } from "../../config/ApiConfig";
import { useTheme } from "@/comn/hooks";

export const LoginHeaderThemeToggle = () => {
    const {
        theme: { isDark },
        setTheme,
    } = useTheme();

    const handleClickButton = () => {
        setTheme((prev) => ({ ...prev, isDark: prev.isDark === "true" ? "false" : "true" }));
    };

    return (
        <button
            className={classNames(
                "flex items-center justify-center bg-black/10 rounded z-[2] w-[36px] h-[36px] hover:bg-black/20",
            )}
            onClick={handleClickButton}
        >
            {isDark === "true" ? (
                <Icon icon="light" size="xs" className="fill-primary-contrast" />
            ) : (
                <Icon icon="dark" size="xs" className="fill-primary-contrast" />
            )}
        </button>
    );
};
